import React from 'react';
import { RouterProvider } from 'react-router-dom';

import ThemeCustomization from './themes';

import Locales from './components/Locales';

import ScrollTop from './components/ScrollTop';

import { JWTProvider as AuthProvider } from './contexts/JWTContext';
import router from './routes';

const App = () => {
  return (
    <ThemeCustomization>
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ScrollTop>
      </Locales>
    </ThemeCustomization>
  );
};

export default App;
